import { action, computed, observable, makeObservable } from 'mobx';

import LearningCollectionEditStore from '../../../Store';
import { setState, State, enterEditMode, leaveEditMode, updateInitialFormHash } from './Types';

class PreviewStore {
  @observable state: State;

  readonly learningCollectionStore: LearningCollectionEditStore;

  constructor(learningCollectionStore: LearningCollectionEditStore, initialFormHash: string) {
    makeObservable(this);
    this.state = setState(initialFormHash);
    this.learningCollectionStore = learningCollectionStore;
  }

  @action
  updateInitialFormHash = (initialFormHash: string) => {
    this.state = updateInitialFormHash(this.state, initialFormHash);
  };

  @action
  enterEditMode = () => {
    this.state = enterEditMode(this.state);
  };

  @action
  leaveEditMode = () => {
    this.state = leaveEditMode(this.state);
  };

  @computed
  get inEditMode(): boolean {
    return this.state.inEditMode;
  }

  @computed
  get unsavedChanges(): boolean {
    return this.learningCollectionStore.currentFormHash
      .map((currentFormHash) => this.state.initialFormHash !== currentFormHash)
      .getOrElse(() => false);
  }
}

export default PreviewStore;
